import styles from "./DropdownSelection.module.css"
import { ReactComponent as ChevronIcon } from "../assets/images/icons/ic-chevron.svg"
import { useEffect, useMemo, useRef, useState } from "react"
import { Each } from "../common/Each"
import useClickOutside from "../common/hooks/useClickOutside"
import TextInput from "./TextInput"

const DropdownSelection = ({ disabled = false, options = [], placeholder = "", defaultOptionIndex = null, onSelect = () => { }, appereance = "default" }) => {
    const [value, setValue] = useState(null)
    const [open, setOpen] = useState(false)
    const ref = useRef(null)
    const [filteredOptions, setFilteredOptions] = useState(options.map((opt, i) => ({ ...opt, __origIndex: i })))
    const [query, setQuery] = useState("")

    useEffect(() => {
        setFilteredOptions(options.map((opt, i) => ({ ...opt, __origIndex: i })))
        if (defaultOptionIndex !== null && options.length > 0 && defaultOptionIndex < options.length) {
            if (!value || (value && value.id !== defaultOptionIndex)) {
                setValue({
                    id: defaultOptionIndex,
                    label: options[defaultOptionIndex].label ?? options[defaultOptionIndex],
                    subtitle: options[defaultOptionIndex].subtitle
                })
            }
        } else {
            setValue(null)
        }
    }, [options, defaultOptionIndex])

    useEffect(() => {
        if (value !== null && value.id !== defaultOptionIndex) {
            onSelect(value?.__origIndex ?? value.id)
            setQuery("")
            setFilteredOptions(options.map((opt, i) => ({ ...opt, __origIndex: i })))
            setOpen(false)
        }
    }, [value])


    const checkClickSearch = (e) => {
        let elId = e?.target?.id
        if (elId.includes('dropdown-search')) {
            return
        }
        else {
            setOpen(false)
        }
    }

    useClickOutside(ref, checkClickSearch)

    const onSearch = (query) => {
        setQuery(query)
        if (query.trim().length === 0) {
            setFilteredOptions(options.map((opt, i) => ({ ...opt, __origIndex: i })))
        }
        else {
            const filtered = options.map((opt, i) => ({ ...opt, __origIndex: i })).filter((option) => {
                if (typeof option === 'string') {
                    return option.toLowerCase().includes(query.trim().toLowerCase())
                } else if (typeof option === 'object' && option.label) {
                    return option.label.toLowerCase().includes(query.trim().toLowerCase()) || (option.subtitle && option.subtitle.toLowerCase().includes(query.trim().toLowerCase()))
                }
                return false
            })
            setFilteredOptions(filtered)
        }
    }

    const className = useMemo(() => {
        switch (appereance) {
            case "default": return {
                container: styles.container,
                optionsContainer: styles.options,
                option: styles.option,
            }
            case "transparent": return {
                container: styles.transparent,
                optionsContainer: styles.inverseOptions,
                option: styles.inverseOption,
            }
            case "embedded": return {
                container: styles.embedded,
                optionsContainer: styles.inverseOptions,
                option: styles.inverseOption,
            }
            default: console.error("Invalid appereance"); break;
        }
    }, [])

    return (
        <div ref={ref} className={className.container}
            onFocus={() => setOpen(true)}
            onBlur={() => setOpen(false)}
            onClick={(e) => {
                if (!disabled) {
                    if (open) {
                        checkClickSearch(e)
                    } else {
                        setOpen(true)
                    }
                }
            }}
            style={{ opacity: disabled ? "0.5" : "1", cursor: disabled ? "default" : "pointer" }}
        >
            {value &&
                <div className={styles.selectedOption}>
                    <div className={styles.title}>{value.label ?? "missing label"}</div>
                    {value.subtitle && <div className={styles.subtitle}>{value.subtitle ?? "missing label"}</div>}
                </div>
            }
            {
                !value && <div className={styles.placeholder}>{placeholder}</div>
            }
            <ChevronIcon className={`${styles.arrow} ${open ? styles.up : styles.down}`} />
            <div className={`${className.optionsContainer} ${open ? styles.open : styles.hidden}`}>
                <TextInput 
                value={query}
                onKeyUp={onSearch} 
                sticky 
                type="search" 
                placeholder={'Cerca...'} 
                style={{ width: '100%', backgroundColor: 'var(--background-color)', zIndex: 2 }} 
                inputStyle={{ border: 'none', borderBottom: '1px solid rgba(var(--text-color-rgb), 12%)', borderRadius: '0',  backgroundColor: 'var(--background-color)' }} />
                <Each
                    of={filteredOptions}
                    render={(option, index) => (
                        <>
                            <div className={className.option} onClick={() => {
                                setValue({
                                    id: index,
                                    __origIndex: option?.__origIndex ?? index,
                                    label: option?.label ?? option,
                                    subtitle: option?.subtitle
                                })
                            }}>
                                <div className={styles.title}>
                                    {option?.label ?? option}
                                </div>
                                <div className={styles.subtitle}>
                                    {option?.subtitle ?? ""}
                                </div>
                            </div>
                            {index !== filteredOptions.length - 1 && <div className={styles.divider} />}
                        </>
                    )}
                />
            </div>
        </div>
    )
}

export default DropdownSelection
